import { useCurrentMembership, useUserType } from 'src/contexts/userContext'

import { TrackingPersona } from './useTracking.types'

export const usePersona = (): TrackingPersona | undefined => {
  const { isBuyer, isSeller } = useUserType()
  const membership = useCurrentMembership()

  if (membership?.optEnableMultiMembershipMode) {
    return TrackingPersona.CENTRAL
  }

  if (isBuyer) {
    return TrackingPersona.BUYER
  }

  if (isSeller) {
    return TrackingPersona.SELLER
  }
}
